import { Image } from "@chakra-ui/react";
import { useMemo } from "react";
import useScreen from "../../../hooks/useScreen";
import { Channel } from "../../../interfaces/tracking";
import { Analytics, EventNames } from "../../../utils/tracking";

interface DownloadPhotoButtonProps {
  imageUrl: string;
  gnomeId: string;
}

export const DownloadPhotoButton = (props: DownloadPhotoButtonProps) => {
  const imageUrl = useMemo(() => props.imageUrl, [props.imageUrl]);
  const gnomeId = useMemo(() => props.gnomeId, [props.gnomeId]);
  const { isMobile } = useScreen();

  const createBlob = async () => {
    const response = await fetch(imageUrl);
    const newblob = await response.blob();
    return newblob;
  };

  const platform: string =
    new URLSearchParams(location.search).get("platform") ?? "";

  const handleDownload = async () => {
    Analytics.event(Channel.GA, EventNames.DOWNLOAD_CLICKED, {
      device: platform.includes("g-mob")
        ? "app"
        : isMobile
        ? "mobile"
        : "desktop",
      style_id: gnomeId,
    });

    const blob = await createBlob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "NewLoookImage.png";
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Image
      cursor="pointer"
      src={process.env.PUBLIC_URL + "/assets/images/download.svg"}
      onClick={handleDownload}
      height={isMobile ? "42px" : "52px"}
      width={isMobile ? "42px" : "52px"}
    />
  );
};
